import { t } from '@lingui/core/macro';
import * as yup from 'yup';
import { EsigningProviderAuthenticationModeSlug } from 'shared/domains/apollo/generated/types';
export function getValidationSchema() {
    return yup.object().shape({
        name: yup.string().trim(),
        firstName: yup
            .string()
            .trim()
            .required(t({ message: 'First name is required', comment: 'Esigning contacts form - First name is required' })),
        lastName: yup
            .string()
            .trim()
            .required(t({ message: 'Last name is required', comment: 'Esigning contacts form - Last name is required' })),
        email: yup
            .string()
            .trim()
            .email()
            .required(t({ message: 'Email is required', comment: 'Esigning contacts form - Email is required' })),
        mobile: yup.string().trim(),
        label: yup.string().trim(),
        title: yup.string().trim(),
        authenticationMode: yup
            .string()
            .trim()
            .oneOf(Object.values(EsigningProviderAuthenticationModeSlug), t({
            message: 'Invalid authentication mode',
            comment: 'Esigning contacts form - Invalid authentication mode',
        })),
    });
}
/**
 * Validate and normalize the contact values.
 *
 * Going forward we want to only save firstName and lastName. And have
 * the name field be a computed field (by backend). However, we have existing contacts
 * that only have a name field. So we need to transform the initial values
 * to match the new format.
 */
export function formatValues(initialValues) {
    if (!initialValues) {
        return {
            name: '',
            firstName: '',
            lastName: '',
            email: '',
            mobile: '',
            label: '',
            title: '',
            authenticationMode: undefined,
            isPublic: false,
        };
    }
    const validateName = (data) => {
        const { firstName, lastName, name } = data;
        const namesExist = firstName.length && lastName.length;
        if (!(name === null || name === void 0 ? void 0 : name.length) || namesExist) {
            return data;
        }
        const [newFirstName, ...lastNames] = name.split(' ');
        return Object.assign(Object.assign({}, data), { name: '', firstName: newFirstName, lastName: lastNames.join(' ') });
    };
    const normalizeValues = (data) => {
        const { name, firstName, lastName, email, mobile, title, label, authenticationMode, isPublic } = data;
        return {
            name: name !== null && name !== void 0 ? name : '',
            firstName: firstName !== null && firstName !== void 0 ? firstName : '',
            lastName: lastName !== null && lastName !== void 0 ? lastName : '',
            email: email !== null && email !== void 0 ? email : '',
            mobile: mobile !== null && mobile !== void 0 ? mobile : '',
            label: label !== null && label !== void 0 ? label : '',
            title: title !== null && title !== void 0 ? title : '',
            authenticationMode: authenticationMode !== null && authenticationMode !== void 0 ? authenticationMode : undefined,
            isPublic: isPublic !== null && isPublic !== void 0 ? isPublic : false,
        };
    };
    return validateName(normalizeValues(initialValues));
}
